export enum NCCoAImportFiles {
	ChartOfAccounts = 1,
	AllotmentCarryover = 2,
	IndirectCost = 3,
	Site = 4,
	CommunicationLog = 5,
}
